<template>
  <div>
    <div class="subBody">
      <Form ref="searchForm" :model="searchForm" inline class="search-form">
        <FormItem>
          <Select v-model="searchForm.campusId" placeholder="选择校区" :transfer="true" @on-change="changeCampus">
            <Option value="0">全部校区</Option>
            <Option value="1">同济新村</Option>
            <Option value="2">政立路</Option>
            <Option value="3">沪西</Option>
            <Option value="53C80DAB9E3225ADE0632084A8C0A196">沪北</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="searchForm.teacherId" placeholder="选择教师" :transfer="true" @on-change="changeTeacher">
            <Option value="0">全部教师</Option>
            <Option v-for="teacher in teacherList" :key="teacher.id" :value="teacher.id">{{ teacher.name }}</Option>
          </Select>
        </FormItem>
        <FormItem class="signup-status-filter">
          <Select v-model="searchForm.isInSignUpPeriod" placeholder="报名状态" :transfer="true"
            @on-change="changeIsInSignUpPeriod">
            <Option value="-1">所有课程</Option>
            <Option value="1">报名中</Option>
            <Option value="0">报名结束</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input search enter-button v-model="searchForm.course" placeholder="搜索课程名称" @on-search="searchCoursel" />
        </FormItem>
      </Form>

      <ul class="proList">
        <li v-for="item in listData" :key="item.id">
          <span class="transformImg img" style="position: relative" @click="viewDetail(item)">
            <img :src="imgurl + item.pictureSrc" />
            <span v-if="item.isInSignUpPeriod" class="is-in-sign-up-tag">报名中</span>
          </span>
          <div class="txtbox">
            <div @click="viewDetail(item)">
              <h2>{{ item.course }}</h2>
              <p>
                教师:{{ item.teacher }}
              </p>
              <p>
                时间:{{ item.classBegin }}
              </p>
              <p>
                校区:{{ item.campusName }}
              </p>
            </div>
            <div class="campus-details">
              <Button type="primary" class="ivu-btn apply-button" :disabled="item.viewApply"
                @click="apply(item)">立即报名</Button>
              <Button type="default" class="ivu-btn details-button" @click="viewDetail(item)">查看详情</Button>
            </div>
          </div>
        </li>
      </ul>
      <div class="page-wrapper" ref="pageWrapper">
        <Page 
          v-if="!isSimpleMode"
          :total="pageTotal" 
          show-total
          :current="currNum" 
          @on-change="handlePage" 
          :page-size="pageSize" 
        />
        <Page 
          v-else
          :total="pageTotal" 
          :simple="true"
          :current="currNum" 
          @on-change="handlePage" 
          :page-size="pageSize" 
        />
      </div>
    </div>
    <apply-flow ref="applyFlow"></apply-flow>
  </div>
</template>
<script>
import applyFlow from "_c/applyFlow.vue";

const MOBILE_HEADER_FOOTER_HEIGHT = 50;

export default {
  data() {
    return {
      searchForm: {
        campusId: "0",
        course: "",
        isInSignUpPeriod: "-1",
        teacherId: "0"
      },
      teacherList: [],
      searchFormHeight: 0,
      pageTotal: 0,
      currNum: 1,
      listData: [],
      basicData: {},
      pageSize: 12,
    };
  },
  components: {
    applyFlow,
  },
  computed: {
    breadCrumbList() {
      //   return this.$store.state.app.breadCrumbList
    },
    isSimpleMode() {
      return window.innerWidth <= 768;
    },
    computedPageSize() {
      if (window.innerWidth <= 768) {
        const hdbgHeightAndFooterHeight = MOBILE_HEADER_FOOTER_HEIGHT;
        const courseCardHeight = 138;
        const gap = 8;

        setTimeout(() => {
          if (this.$refs.searchForm && this.$refs.pageWrapper) {
            const searchFormHeight = this.$refs.searchForm.$el.offsetHeight;
            const paginationHeight = this.$refs.pageWrapper.offsetHeight;
            console.log('实际搜索表单高度:', searchFormHeight);
            console.log('实际分页区域高度:', paginationHeight);
            const containerHeight = window.innerHeight +20 - hdbgHeightAndFooterHeight - searchFormHeight - paginationHeight;
            console.log('容器可用高度:', containerHeight + gap);
            console.log('卡片高度:', courseCardHeight + gap);
            const rows = Math.floor((containerHeight + gap) / (courseCardHeight + gap * 2));
            console.log('行数:', rows);
            this.pageSize = rows * 2;
            if (this.allListData) {
              console.log('allListData:', this.allListData);
              const start = (this.currNum - 1) * this.pageSize;
              const end = start + this.pageSize;
              this.displayPage(start, end);
            }
          }
        }, 0);

        return this.pageSize;
      }
      return 12;
    }
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 768) {
        this.pageSize = this.computedPageSize;
        this.resetData();
      } else {
        this.pageSize = 12;
      }
    },
    resetData() {
      this.currNum = 1;
      let params = {
        course: this.searchForm.course,
        campusId: this.searchForm.campusId,
        startIndex: 0,
        endIndex: this.pageSize,
        isInSignUpPeriod: this.searchForm.isInSignUpPeriod,
        teacherId: this.searchForm.teacherId
      };
      this.getData(params);
    },
    changeCampus() {
      this.resetData();
    },
    changeTeacher() {
      this.resetData();
    },
    changeIsInSignUpPeriod() {
      this.resetData();
    },
    displayPage(star, end) {
      this.listData = this.allListData.slice(star, end);
    },
    getData(e) {
      var _this = this;
      _this.$http
        .get("retire-school-manage/personal/getSchoolCourses", {
          params: {
            course: e.course,
            campusId: e.campusId,
            startIndex: 1,
            endIndex: 1024,
            isInSignUpPeriod: e.isInSignUpPeriod,
            empId: e.teacherId === "0" ? null : e.teacherId,
            ...this.basicData
          },
        })
        .then(function (res) {
          if (res.data.status === 2000) {
            _this.allListData = res.data.data.schoolCourseList.map(item => {
              item.viewApply = false;
              if (_this.$store.state.studentId) {
                if (
                  item.signUpCnt == item.courseNumber ||
                  item.flag == "N"
                ) {
                  item.viewApply = true;
                } else {
                  item.viewApply = false;
                }
              } else {
                item.viewApply = true;
              }
              return item;
            })
              .sort((item1, item2) => {
                return item1.viewApply - item2.viewApply;
              });
            _this.displayPage(e.startIndex, e.startIndex + _this.pageSize);
            //获取分页的总条数
            _this.pageTotal = parseInt(res.data.data.cnt);
          } else if (res.data.status === 9000) {
            _this.listData = [];
            _this.pageTotal = 0;
          } else {
            _this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handlePage(value) {
      this.currNum = value;
      var currTemp = value - 1;
      var star = currTemp * this.pageSize;
      var end = currTemp * this.pageSize + this.pageSize;
      this.displayPage(star, end);
    },
    searchCoursel() {
      let par = {
        course: this.searchForm.course,
        campusId: this.searchForm.campusId,
        startIndex: 0,
        endIndex: this.pageSize,
        isInSignUpPeriod: this.searchForm.isInSignUpPeriod,
        teacherId: this.searchForm.teacherId
      };
      this.getData(par);
    },
    apply(val) {
      this.$refs.applyFlow.applyConfirm(val.id, val.course);
    },
    initBasicData() {
      let _this = this;
      return new Promise(resolve => {
        if (this.$store.state.studentId) {
          this.$http
            .get("retire-school-manage/personal/getMyInfo", {
              params: {
                studentId: this.$store.state.studentId
              }
            })
            .then(res => {
              if (res.data.status === 2000) {
                this.basicData = {
                  sid: res.data.data.sid,
                  studentId: _this.$store.state.studentId
                };
                resolve();
              } else {
                console.log("数据获取失败");
                resolve();
              }
            })
            .catch(err => {
              console.log(err);
              resolve();
            });
        } else {
          this.basicData = {};
          resolve();
        }
      });
    },
    viewDetail(val) {
      let year;
      let xq;

      year = val.year.substr(0, 4);
      xq = val.year.substr(4, 5);

      this.$router.push({
        name: "detail",
        query: {
          ...this.basicData,
          id: val.id,
          courseNo: val.courseNo,
          year: year,
          xq: xq
        }
      });
    },
    toAllProList() {
      this.$router.push({ name: "allCourse" });
    },
    loadTeacherList() {
      this.$http
        .get("retire-school-manage/course/getAllTeachers")
        .then(res => {
          if (res.data.status === 2000) {
            this.teacherList = Object.entries(res.data.data).map(([id, name]) => ({
              id: id,
              name: name
            }));
          } else {
            this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  created() {
    this.loadTeacherList();
    let e = {
      course: "",
      campusId: "",
      startIndex: 0,
      endIndex: this.computedPageSize,
      isInSignUpPeriod: "-1",
      teacherId: "0"
    };
    this.pageSize = this.computedPageSize;
    this.initBasicData().then(() => {
      this.getData(e);
    });
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.searchForm) {
        this.searchFormHeight = this.$refs.searchForm.$el.offsetHeight;
        this.handleResize();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="less" scoped>
@import '../../styles/base/_variables.less';

// 程列表响应式样式
.subBody {
  width: 100%;
  padding: 10px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;

  // 默认样式（移动优先）
  .search-form {
    margin-bottom: 10px;
    width: 100%;

    .ivu-form-item {
      margin-bottom: 8px;
      width: 100%;
    }
  }

  .page-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    padding: 8px 0;
    margin: 0;
    z-index: 10;

    @media (max-width: @screen-sm) {
      /deep/ .ivu-page {
        font-size: 14px;
        
        &-prev, &-next {
          min-width: 32px;
          height: 32px;
          line-height: 30px;
          a {
            font-size: 14px;
          }
        }

        &-simple {
          .ivu-page-simple-pager {
            font-size: 14px;
            margin: 0 8px;
            
            input {
              font-size: 14px;
              height: 32px;
              line-height: 30px;
              padding: 0 8px;
              border-radius: 4px;
              margin: 0 8px;
              width: 40px;
              text-align: center;
            }

            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  // 大屏幕样式
  @media (min-width: @screen-sm) {
    width: 96%;
    max-width: 1400px;
    padding: 30px 0;

    .search-form {
      display: inline-block;
      width: auto;
      padding-left: 20px;

      .ivu-form-item {
        margin-bottom: 0;
        margin-right: 10px;
        display: inline-block;
        width: auto;

        .ivu-input-wrapper {
          width: 200px !important;

          .ivu-input {
            height: 48px;
            font-size: 16px;
            padding: 10px 20px;
          }
        }
      }
    }
  }

  // 小屏幕样式
  @media (max-width: @screen-sm) {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: calc(100vh - @mobile-header-footer-height);

    .search-form {
      position: sticky;
      top: 0;
      z-index: 10;
      background: #fff;
      padding: 6px;
      margin-bottom: 0;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-wrap: wrap;
      gap: 6px;

      .teacher-filter,
      .signup-status-filter {
        display: none;
      }

      .ivu-form-item {
        margin: 0;
        width: calc(50% - 4px);

        &:last-child {
          width: 100%;
        }

        .ivu-input-wrapper {
          width: 100% !important;

          .ivu-input {
            height: 32px;
            line-height: 30px;
            font-size: 13px;
            padding: 0 8px;
          }

          .ivu-input-search {
            i {
              font-size: 14px;
            }
          }

          .ivu-input-group-append {
            .ivu-btn {
              height: 32px;
              line-height: 30px;
              padding: 0 12px;
              font-size: 13px;
            }
          }
        }
      }
    }

    .proList {
      flex: 1;
      min-height: 0;
      padding: 6px 2%;
    }

    .page-wrapper {
      position: sticky;
      background: #fff;
      box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
    }

  }
}

// 课程列表样式
.proList {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  padding: 15px;
  margin: 0;
  align-content: start;

  @media (min-width: @screen-sm) {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 20px;
  }

  li {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s, box-shadow 0.2s;
    height: fit-content;
    display: flex;
    flex-direction: column;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .transformImg {
      width: 100%;
      height: 160px;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s;
      }
    }

    .txtbox {
      padding: 12px;

      h2 {
        font-size: 18px;
        margin-bottom: 8px;
        line-height: 1.4;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p {
        color: #666;
        margin-bottom: 6px;
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .campus-details {
        margin-top: 12px;
        display: flex;
        gap: 8px;

        .ivu-btn {
          flex: 1;
          height: 32px;
        }
      }
    }
  }

  @media (max-width: @screen-sm) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    padding: 8px;

    li {
      .transformImg {
        display: none;
      }

      .txtbox {
        padding: 8px;
        height: 100%;
        display: flex;
        flex-direction: column;

        h2 {
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 6px;
          line-height: 1.3;
          max-height: 36px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        p {
          font-size: 13px;
          margin-bottom: 4px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .campus-details {
          margin-top: auto;
          gap: 4px;

          .ivu-btn {
            height: 26px;
            font-size: 13px;
            padding: 0 8px;
          }
        }
      }
    }
  }
}

// 报名中标签样式
.is-in-sign-up-tag {
  zoom: 125%;
  position: absolute;
  bottom: 0px;
  right: 10px;
  background: @primary-color;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
